module.exports = __webpack_public_path__ + "static/media/composer-down-arrow.7abf9a05.svg";